var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-help",on:{"click":_vm.click}},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("?")])])}
var staticRenderFns = []

export { render, staticRenderFns }